import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SkipNav, Alert } from '@ver-uds/uswds-react';
import { PageHeader } from '@ver-uds/react';
import { isToggleEnabled, ToggleName, isIE } from '@save/utils';

export default function SupportedBrowsers() {
  const isUnsupportedBrowserMessageEnabled = isToggleEnabled(ToggleName.RevealUnsupportedBrowser);
  const showUnsupportedBrowserMessage = isIE() && isUnsupportedBrowserMessageEnabled;

  return (
    <>
      <Helmet>
        <title>SAVE - Supported Browsers</title>
      </Helmet>
      <SkipNav.MainContent>
        <PageHeader>Browser Support</PageHeader>
        <div className="grid-container">
          <section className="usa-section padding-top-4">
            <div className="grid-row grid-gap">
              {showUnsupportedBrowserMessage && (
                <div className="padding-1">
                  <Alert status="warning" data-testid="browserUnsupportedMessage">
                    <Alert.Heading>Your Browser Is Not Supported</Alert.Heading>
                    <Alert.Text>
                      You may experience technical difficulties using SAVE with your current browser. Please utilize one
                      of the suggested alternatives.
                    </Alert.Text>
                  </Alert>
                </div>
              )}

              <p className="margin-bottom-3">
                In June 2022, Microsoft will discontinue support for the Internet Explorer browser. In an effort to keep
                SAVE’s systems modern and secure, we will also discontinue support for Internet Explorer and encourage
                our users to switch to one of the modern browsers below:
              </p>

              <ul className="usa-list usa-list--unstyled">
                <li>
                  <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a>
                </li>
                <li>
                  <a href="https://www.google.com/chrome/">Google Chrome</a>
                </li>
                <li>
                  <a href="https://www.apple.com/safari/">Apple Safari</a>
                </li>
                <li>
                  <a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox</a>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </SkipNav.MainContent>
    </>
  );
}
